/**
 * Plural en castellano, dicho como lo diría una persona.
 *
 * ⚠️ **`«1 conversación(es) · 0 hora(s)»` no lo escribe nadie: lo escribe un programa**, y el
 * cliente lo lee así. Estaba repetido unas veinte veces en las cinco pantallas —contactos, tareas,
 * productos, variantes, citas, pagos, llegadas— porque cada una resolvió el plural por su cuenta
 * con un `(s)` pegado al final. Acá se resuelve una vez.
 *
 * La forma plural va explícita y no se deriva agregando una `s`: en castellano hay demasiadas
 * excepciones (`vez`→`veces`, `mes`→`meses`) y una regla que acierta el 80 % de las veces es peor
 * que escribir las dos palabras, porque el 20 % restante no avisa.
 *
 * El número va con separador de miles: «1.240 contactos» y no «1240 contactos».
 */
export function plural(n, singular, plural_, { numero = true } = {}) {
  const cantidad = Number(n) || 0;
  const palabra = cantidad === 1 ? singular : plural_;
  return numero ? `${cantidad.toLocaleString('es-CL')} ${palabra}` : palabra;
}
